module.exports = __webpack_public_path__ + "p6_img2.jpg?8041570b78b2ce6e7d4f615d46d0ddee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img2.jpg
// module id = 180
// module chunks = 0